export default __webpack_public_path__ + "static/media/flag-saint-lucia.7d895548.svg";